// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__ZFTfG","box":"WorkspacesBox_box__Ctn4T","node":"WorkspacesBox_node__1m2J9"};